import { render } from "./wage.vue?vue&type=template&id=5b8b0d18"
import script from "./wage.vue?vue&type=script&lang=js"
export * from "./wage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__